var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStampSolidFull1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "stamp-solid-full",
    className: "cls-1",
    d: "M376,265.8c0-17.4,9.2-33.2,19.9-47a96,96,0,1,0-151.8,0c10.7,13.8,19.9,29.6,19.9,47A54.243,54.243,0,0,1,209.8,320H176A111.944,111.944,0,0,0,64,432a48.012,48.012,0,0,0,48,48H528a48.012,48.012,0,0,0,48-48A111.944,111.944,0,0,0,464,320H430.2A54.243,54.243,0,0,1,376,265.8ZM120,528a24,24,0,0,0,0,48H520a24,24,0,0,0,0-48Z",
    transform: "translate(-64 -64)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStampSolidFull1);
export default __webpack_public_path__ + "static/media/stamp-solid-full (1).5e0f05b84751a64984f1aab250888ac4.svg";
export { ForwardRef as ReactComponent };